module.exports = __webpack_public_path__ + "img/dot_flow.8e4ca51f.gif";